"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescriptionBlock = exports.QuestionIcon = exports.CalendarIcon = exports.Eye = exports.InputError = exports.PrettyText = exports.PlaceholderTop = exports.StyledInput = exports.InputContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../assets/js/constants");

var _calendar = _interopRequireDefault(require("../../assets/img/icons/calendar.svg"));

var _question = _interopRequireDefault(require("../../assets/img/icons/question.svg"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var InputContainer = _styledComponents["default"].div.withConfig({
  displayName: "styles__InputContainer",
  componentId: "sc-18hpmhi-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    margin-bottom: 20px;\n    position: relative;\n    flex-direction: column;\n"])));

exports.InputContainer = InputContainer;

var StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "styles__StyledInput",
  componentId: "sc-18hpmhi-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 48px;\n    width: 100%;\n    padding: ", ";\n    padding-right: ", ";\n    font: 300 16px ", ";\n    border: 1px solid ", ";\n    opacity: ", ";\n    border-radius: 4px;\n    transition: border 0.2s ease-in;\n    outline: none;\n    box-shadow: none;\n    box-sizing: border-box;\n    &:focus {\n        border-color: ", ";\n        padding: 13px ", " 0 20px;\n    }\n    &:disabled {\n      border-color: ", ";\n      background-color: ", ";\n    }\n    &::placeholder,\n    &:-ms-input-placeholder,\n    &::-ms-input-placeholder {\n        color: ", ";\n        opacity: 1;\n    }\n    &::-ms-clear,\n    &::-ms-reveal,\n    &:focus::-ms-clear, ::-ms-reveal {\n        display: none !important;\n    }\n    &[type=number]::-webkit-inner-spin-button,\n    &[type=number]::-webkit-outer-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n    }\n    -webkit-text-security: ", "!important;\n"])), function (props) {
  return props.value || props.isHasMask ? '13px 20px 0 20px' : '0 20px';
}, function (props) {
  return props.isIconExist ? '50px' : '20px';
}, _constants.FONTS.light, function (props) {
  return props.notValid ? _constants.COLORS.red : props.valid ? _constants.COLORS.green : _constants.COLORS.grey;
}, function (props) {
  return props.pretty ? '0' : '1';
}, _constants.COLORS.black, function (props) {
  return props.isIconExist ? '50px' : '20px';
}, _constants.COLORS.grey, _constants.COLORS.outlineGrey, _constants.COLORS.darkGrey, function (props) {
  return props.showText ? 'none' : 'disc';
});

exports.StyledInput = StyledInput;

var PlaceholderTop = _styledComponents["default"].span.withConfig({
  displayName: "styles__PlaceholderTop",
  componentId: "sc-18hpmhi-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    white-space: nowrap;\n    height: 18px;\n    overflow: hidden;\n    max-width: ", ";\n    box-sizing: border-box;\n    padding: 1px 0 0 20px;\n    position: absolute;\n    font-size: 13px;\n    color: ", ";\n    opacity: 1;\n    transition: 0.2s opacity;\n    top: 0;\n    line-height: 18px;\n    left: 0;\n"])), function (props) {
  return props.isIconExist ? 'calc(100% - 50px)' : 'calc(100% - 20px)';
}, _constants.COLORS.middleGray);

exports.PlaceholderTop = PlaceholderTop;

var PrettyText = _styledComponents["default"].div.withConfig({
  displayName: "styles__PrettyText",
  componentId: "sc-18hpmhi-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    height: 48px;\n    padding: 13px 20px 0 20px;\n    font: 300 16px ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    transition: border 0.2s ease-in;\n    outline: none;\n    box-shadow: none;\n    background: ", ";\n    align-items: center;\n    width: inherit;\n    position: absolute;\n    box-sizing: border-box;\n    top: 0;\n"])), _constants.FONTS.light, _constants.COLORS.green, _constants.COLORS.white);

exports.PrettyText = PrettyText;

var InputError = _styledComponents["default"].p.withConfig({
  displayName: "styles__InputError",
  componentId: "sc-18hpmhi-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    opacity: ", ";\n    font-size: ", ";\n    line-height: 2em;\n    margin: 0;\n    color: ", ";\n    transition: opacity 0.2s ease-in-out;\n"])), function (props) {
  return props.show ? 1 : 0;
}, function (props) {
  return props.show ? '12px' : 0;
}, _constants.COLORS.red);

exports.InputError = InputError;

var Eye = _styledComponents["default"].div.withConfig({
  displayName: "styles__Eye",
  componentId: "sc-18hpmhi-5"
})(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    position: absolute;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: 50%;\n    top: 0;\n    right: 10px;\n    width: 48px;\n    height: 48px;\n    cursor: pointer;\n"])), function (props) {
  return props.open ? require('../../assets/img/icons/eye-closed.svg') : require('../../assets/img/icons/eye-opened.svg');
});

exports.Eye = Eye;

var CalendarIcon = _styledComponents["default"].div.withConfig({
  displayName: "styles__CalendarIcon",
  componentId: "sc-18hpmhi-6"
})(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    position: absolute;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: 50%;\n    top: 0;\n    right: 10px;\n    width: 48px;\n    height: 48px;\n    cursor: pointer;\n"])), _calendar["default"]);

exports.CalendarIcon = CalendarIcon;

var QuestionIcon = _styledComponents["default"].div.withConfig({
  displayName: "styles__QuestionIcon",
  componentId: "sc-18hpmhi-7"
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    position: absolute;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-position: 50%;\n    top: 0;\n    right: 10px;\n    width: 48px;\n    height: 48px;\n    cursor: pointer;\n"])), _question["default"]);

exports.QuestionIcon = QuestionIcon;

var DescriptionBlock = _styledComponents["default"].div.withConfig({
  displayName: "styles__DescriptionBlock",
  componentId: "sc-18hpmhi-8"
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    font-size: 12px;\n    line-height: 2em;\n    margin: 0;\n    color: ", ";\n"])), _constants.COLORS.grey);

exports.DescriptionBlock = DescriptionBlock;